import React from 'react';

const ProfessorStatsHeader = ({ professor, finalTier, onBack, setInfoOpen }) => {
    const name = professor.employeeName || "Professor";
    const score = Number(professor.scoreFinal).toFixed(1);

    return (
        <div
            className="w-100 position-relative flex-shrink-0"
            style={{
                background: "linear-gradient(135deg, rgba(10,22,40,0.95) 0%, rgba(26,42,74,0.95) 100%)",
                minHeight: '130px',
                display: 'flex',
                borderBottom: '1px solid rgba(255,255,255,0.06)',
                zIndex: 2
            }}
        >
            {/* HEADER DESKTOP (md+) */}
            <div className="container-fluid px-4 py-3 position-relative d-none d-md-flex flex-row align-items-center justify-content-between gap-3" style={{ zIndex: 2 }}>

                <div className="d-flex flex-row align-items-center gap-3" style={{ maxWidth: "65%" }}>
                    {/* Back Button */}
                    <button
                        onClick={onBack}
                        className="btn rounded-circle d-flex align-items-center justify-content-center border-0 flex-shrink-0"
                        style={{
                            width: "44px", height: "44px",
                            background: "rgba(255,255,255,0.08)",
                            transition: "all 0.2s"
                        }}
                        title="Voltar"
                    >
                        <i className="mdi mdi-arrow-left text-white font-size-22"></i>
                    </button>

                    {/* Avatar + Info */}
                    <div className="d-flex align-items-center gap-3">
                        <div style={{
                            width: "80px", height: "80px", flexShrink: 0,
                            borderRadius: "50%",
                            padding: "3px",
                            background: `linear-gradient(135deg, ${finalTier.color}, ${finalTier.color}66)`,
                            boxShadow: `0 4px 15px ${finalTier.color}33`
                        }}>
                            <div style={{
                                width: "100%", height: "100%",
                                borderRadius: "50%", overflow: "hidden",
                                border: "3px solid rgba(10,22,40,0.9)"
                            }}>
                                {professor.employeePhotoUrl ? (
                                    <img
                                        src={professor.employeePhotoUrl}
                                        alt={name}
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                ) : (
                                    <div
                                        className="w-100 h-100 d-flex align-items-center justify-content-center fw-bold"
                                        style={{
                                            backgroundColor: `${finalTier.color}22`,
                                            color: finalTier.color,
                                            fontSize: "28px"
                                        }}
                                    >
                                        {name.charAt(0)}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div>
                            <h3 className="fw-bold text-white mb-0"
                                style={{
                                    letterSpacing: "-0.5px",
                                    fontSize: name.length > 25 ? "1.3rem" : name.length > 15 ? "1.5rem" : "1.8rem",
                                    lineHeight: "1.2"
                                }}>
                                {name}
                            </h3>
                            <div className="d-flex align-items-center gap-2 mt-2">
                                <span
                                    className="badge px-3 py-1 font-size-13 fw-bold text-uppercase rounded-pill"
                                    style={{
                                        backgroundColor: `${finalTier.color}22`,
                                        color: finalTier.color === '#e9ecef' ? 'rgba(255,255,255,0.6)' : finalTier.color,
                                        border: `1px solid ${finalTier.color}44`,
                                        letterSpacing: "0.5px"
                                    }}
                                >
                                    <i className="mdi mdi-star me-1"></i> {finalTier.label}
                                </span>
                                <button
                                    onClick={() => setInfoOpen(true)}
                                    className="btn btn-sm p-0 d-flex align-items-center justify-content-center"
                                    style={{ width: "24px", height: "24px", color: "rgba(255,255,255,0.3)" }}
                                >
                                    <i className="mdi mdi-information-outline font-size-18"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Score Pill */}
                <div
                    className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 flex-shrink-0"
                    style={{
                        background: "rgba(255,255,255,0.06)",
                        border: "1px solid rgba(255,255,255,0.08)",
                        backdropFilter: "blur(10px)"
                    }}
                >
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                            width: '40px', height: '40px',
                            backgroundColor: `${finalTier.color}22`
                        }}
                    >
                        <i className="mdi mdi-seal font-size-22" style={{ color: finalTier.color === '#e9ecef' ? 'rgba(255,255,255,0.4)' : finalTier.color }}></i>
                    </div>
                    <div className="text-end">
                        <div className="text-uppercase fw-bold mb-0 lh-1" style={{ fontSize: "10px", letterSpacing: "1.5px", color: "rgba(255,255,255,0.35)" }}>Score Geral</div>
                        <div className="fw-bold text-white mt-1 d-flex align-items-baseline gap-1" style={{ fontSize: "1.5rem" }}>
                            {score} <span className="font-size-13" style={{ color: "rgba(255,255,255,0.3)" }}>%</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* HEADER MOBILE (<md) */}
            <div className="container-fluid px-3 py-3 position-relative d-flex d-md-none flex-row align-items-center justify-content-between gap-2" style={{ zIndex: 2 }}>

                <div className="d-flex flex-row align-items-center gap-2" style={{ maxWidth: "65%" }}>
                    <div style={{
                        width: "60px", height: "60px", flexShrink: 0,
                        borderRadius: "50%",
                        padding: "2px",
                        background: `linear-gradient(135deg, ${finalTier.color}, ${finalTier.color}66)`
                    }}>
                        <div style={{
                            width: "100%", height: "100%",
                            borderRadius: "50%", overflow: "hidden",
                            border: "2px solid rgba(10,22,40,0.9)"
                        }}>
                            {professor.employeePhotoUrl ? (
                                <img src={professor.employeePhotoUrl} alt={name}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            ) : (
                                <div className="w-100 h-100 d-flex align-items-center justify-content-center fw-bold"
                                    style={{ backgroundColor: `${finalTier.color}22`, color: finalTier.color, fontSize: "20px" }}>
                                    {name.charAt(0)}
                                </div>
                            )}
                        </div>
                    </div>

                    <div>
                        <h4 className="fw-bold text-white mb-0"
                            style={{
                                fontSize: name.length > 25 ? "1.1rem" : name.length > 15 ? "1.3rem" : "1.5rem",
                                lineHeight: "1.2", wordBreak: "break-word"
                            }}>
                            {name}
                        </h4>
                        <div className="d-flex align-items-center gap-1 mt-1">
                            <span className="badge px-2 py-1 font-size-11 fw-bold text-uppercase rounded-pill"
                                style={{
                                    backgroundColor: `${finalTier.color}22`,
                                    color: finalTier.color === '#e9ecef' ? 'rgba(255,255,255,0.6)' : finalTier.color,
                                    border: `1px solid ${finalTier.color}44`
                                }}>
                                <i className="mdi mdi-star me-1"></i> {finalTier.label}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Score */}
                <div className="d-flex align-items-center gap-1 rounded-pill px-2 py-1 flex-shrink-0"
                    style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.08)" }}>
                    <div className="text-end pe-1">
                        <div className="text-uppercase fw-bold" style={{ fontSize: "9px", letterSpacing: "1px", color: "rgba(255,255,255,0.3)" }}>Score</div>
                        <div className="fw-bold text-white d-flex align-items-baseline gap-1" style={{ fontSize: "1.3rem" }}>
                            {score} <span className="font-size-11" style={{ color: "rgba(255,255,255,0.3)" }}>%</span>
                        </div>
                    </div>
                </div>

                {/* Mobile Back */}
                <div className="position-absolute" style={{ top: '12px', left: '12px', zIndex: 10 }}>
                    <button onClick={onBack}
                        className="btn rounded-circle d-flex align-items-center justify-content-center border-0"
                        style={{ width: "36px", height: "36px", background: "rgba(255,255,255,0.08)" }}>
                        <i className="mdi mdi-arrow-left text-white font-size-18"></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProfessorStatsHeader;
